import { AbstractOptionSelectableTextItem } from "./AbstractOptionSelectableTextItem";
import { PaintStyle } from "../../drawing";
import { TypeKeys } from "./TypeKeys";
import { IEmptyValidatable } from "./IEmptyValidatable";
import { IPaintableOnEditing } from "./IPaintableOnEditing";
import { DataValidationKinds } from "../DataValidationKinds";
import { ITextValidatable } from "./ITextValidatable";
import { INaturalTextSpecifiable } from "./INaturalTextSpecifiable";

export class RollItem extends AbstractOptionSelectableTextItem implements IEmptyValidatable, IPaintableOnEditing, ITextValidatable, INaturalTextSpecifiable {
  constructor(value: any, selectedSource: string | number) {
    super(TypeKeys.RollItem, value, selectedSource);
  }

  public paintStyleOnEditing = new PaintStyle(); // v1の表示用背景色が透過なので透過にしておく
  public dataValidationKind: DataValidationKinds = null;
  public isNaturalViewEnable: boolean;
  public naturalText: string;

  protected createCloneInstance(): RollItem {
    return new RollItem(this.originalValue, this.originalValueSource);
  }

  protected applyMembers(clone: RollItem): void {
    super.applyMembers(clone);
    clone.paintStyleOnEditing = this.cloneValue(this.paintStyleOnEditing);
    clone.dataValidationKind = this.cloneValue(this.dataValidationKind);
    clone.isNaturalViewEnable = this.cloneValue(this.isNaturalViewEnable);
    clone.naturalText = this.cloneValue(this.naturalText);
  }

  shouldValidateText(): boolean {
    return this.isFreeInputable && this.shouldInputFree;
  }

  get currentNaturalText(): string {
    return this.isNaturalViewEnable && this.naturalText
      ? this.naturalText
      : this.text();
  }
}
